export default function initAdvancedExpandAreaToggle() {
    const sections = document.querySelectorAll('.ExpandAreaWithFilters__expandArea');
    const windowWidth = window.innerWidth;

    sections.forEach(section => {

        console.log(`Section id = ${section.id}`);

        const toggleBtn = section.querySelector('[id^="toggleAdvancedExpandArea"]');
        const toggleBtnB = section.querySelector('[id^="toggleAdvancedExpandAreaB"]');

        const expandPanel = document.getElementById(`advancedExpandArea-${section.id}`);        
        
        const filtersSection = section.querySelector('.filtersA');
        const filtersSectionB = section.querySelector('.filtersB');
        const icon = toggleBtn?.querySelector('i');
        const iconB = toggleBtnB?.querySelector('i'); 

        if (!toggleBtn || !toggleBtnB || !expandPanel || !filtersSection || !filtersSectionB || !icon || !iconB) {
            console.warn(`Missing toggle/panel for section ${section.id}`);
            return;
        }

        // Setup filter buttons
        const filterButtons = filtersSection.querySelectorAll('input[type="radio"]');
        const filterButtonsB = filtersSectionB.querySelectorAll('input[type="radio"]');
        const rectangles = expandPanel.querySelectorAll('.col');

        toggleBtn.addEventListener('click', () => {
            const isOpen = expandPanel.classList.toggle('open');
            expandPanel.classList.toggle('mb-4', isOpen);            
            filtersSection.classList.toggle('open', isOpen);
            filtersSectionB.classList.toggle('open', isOpen);
            icon.classList.toggle('collapsed', !isOpen);  
            iconB.classList.toggle('collapsed', !isOpen);                     

            if(!isOpen) {
                rectangles.forEach(rectangle => {
                    rectangle.classList.remove('d-none');                    
                });

                // ---------------------------

                // When closing: de-select all buttons, and
                // select only the "All" button (so that you'll find it selected when you re open the section)
                filterButtons.forEach(button => {
                    // Uncheck all buttons
                    button.checked = false;
                });

                filterButtonsB.forEach(button => {
                    // Uncheck all buttons
                    button.checked = false;
                });                
                
                const dynamicId = `All-${section.id}`;
                const dynamicIdB = `AllB-${section.id}`;
                
                // Find and check the radio button with the generated ID
                const allButton = document.querySelector(`input[type="radio"][id="${dynamicId}"]`);
                const allButtonB = document.querySelector(`input[type="radio"][id="${dynamicIdB}"]`);
                if (allButton) {
                    allButton.checked = true; // Check the radio button with id All-${section.id}
                }
                if (allButtonB) {
                    allButtonB.checked = true; // Check the radio button with id All-${section.id}
                }
            }                
        }); 
        
        toggleBtnB.addEventListener('click', () => {
            const isOpen = expandPanel.classList.toggle('open');
            expandPanel.classList.toggle('mb-4', isOpen);            
            filtersSection.classList.toggle('open', isOpen);
            filtersSectionB.classList.toggle('open', isOpen);            
            icon.classList.toggle('collapsed', !isOpen);
            iconB.classList.toggle('collapsed', !isOpen);            

            if(!isOpen) {
                rectangles.forEach(rectangle => {
                    rectangle.classList.remove('d-none');                    
                });

                // ---------------------------

                // When closing: de-select all buttons, and
                // select only the "All" button (so that you'll find it selected when you re open the section)
                filterButtons.forEach(button => {
                    // Uncheck all buttons
                    button.checked = false;
                });

                filterButtonsB.forEach(button => {
                    // Uncheck all buttons
                    button.checked = false;
                });
                
                const dynamicId = `All-${section.id}`;
                const dynamicIdB = `AllB-${section.id}`;
                
                // Find and check the radio button with the generated ID
                const allButton = document.querySelector(`input[type="radio"][id="${dynamicId}"]`);
                const allButtonB = document.querySelector(`input[type="radio"][id="${dynamicIdB}"]`);
                if (allButton) {
                    allButton.checked = true; // Check the radio button with id All-${section.id}
                }
                if (allButtonB) {
                    allButtonB.checked = true; // Check the radio button with id All-${section.id}
                }
            }
        }); 

        filterButtons.forEach(button => {
            button.addEventListener('change', function () {
                const selectedValue = this.value;

                rectangles.forEach(rectangle => {
                    const rectValue = rectangle.getAttribute('value');
                    if (!selectedValue || rectValue === selectedValue) {
                        rectangle.classList.remove('d-none');
                    } else {
                        rectangle.classList.add('d-none');
                    }
                });

                // If the button is selected, find the corresponding radio button in the second group
                const id = button.id.replace('-', 'B-'); // Replace "...-.." with "...B-.." to find the matching button                
                const correspondingButton = document.getElementById(id); // Find the radio button with the same id in the second group
                
                if (correspondingButton) {
                    correspondingButton.checked = true; // Select the corresponding radio button in the second group
                }
            });
        });

        filterButtonsB.forEach(button => {
            button.addEventListener('change', function () {
                const selectedValue = this.value;

                rectangles.forEach(rectangle => {
                    const rectValue = rectangle.getAttribute('value');
                    if (!selectedValue || rectValue === selectedValue) {
                        rectangle.classList.remove('d-none');
                    } else {
                        rectangle.classList.add('d-none');
                    }
                });

                const id = button.id.replace('B-', '-'); // Replace "...B-.." with "...-.." to find the matching button    
                const correspondingButton = document.getElementById(id);
                
                if (correspondingButton) {
                    correspondingButton.checked = true; // Select the corresponding radio button in the first group
                }
            });
        });
    




        
    });    
}

/*export default*/ function initAdvancedExpandAreaToggleOld() {
    const totalSections = document.querySelectorAll('.ExpandAreaWithFilters__expandArea').length;
    const windowWidth = window.innerWidth;

    for (let i = 1; i <= totalSections; i++) {        
        
        const toggleBtn = document.getElementById(`toggleAdvancedExpandArea-${i}`);
        const toggleBtnB = document.getElementById(`toggleAdvancedExpandAreaB-${i}`);
        const expandPanel = document.getElementById(`advancedExpandArea-${i}`);        
        // const filtersSection = document.querySelectorAll('.ExpandAreaWithFilters__expandArea')[i - 1].querySelector('.ExpandAreaWithFilters__expandArea__filters');
        const filtersSection = document.querySelectorAll('.ExpandAreaWithFilters__expandArea')[i - 1].querySelector('.filtersA');
        const filtersSectionB = document.querySelectorAll('.ExpandAreaWithFilters__expandArea')[i - 1].querySelector('.filtersB');
        const icon = toggleBtn?.querySelector('i');
        const iconB = toggleBtnB?.querySelector('i'); 

        if (!toggleBtn || !toggleBtnB || !expandPanel || !filtersSection || !filtersSectionB || !icon || !iconB) {
            console.warn(`Missing toggle/panel for section ${i}`);
            continue;
        }

        // Setup filter buttons
        const filterButtons = filtersSection.querySelectorAll('input[type="radio"]');
        const filterButtonsB = filtersSectionB.querySelectorAll('input[type="radio"]');
        const rectangles = expandPanel.querySelectorAll('.col');

        toggleBtn.addEventListener('click', () => {
            const isOpen = expandPanel.classList.toggle('open');
            expandPanel.classList.toggle('mb-4', isOpen);            
            filtersSection.classList.toggle('open', isOpen);
            filtersSectionB.classList.toggle('open', isOpen);
            icon.classList.toggle('collapsed', !isOpen);  
            iconB.classList.toggle('collapsed', !isOpen);                     

            if(!isOpen) {
                rectangles.forEach(rectangle => {
                    rectangle.classList.remove('d-none');                    
                });

                // ---------------------------

                // When closing: de-select all buttons, and
                // select only the "All" button (so that you'll find it selected when you re open the section)
                filterButtons.forEach(button => {
                    // Uncheck all buttons
                    button.checked = false;
                });

                filterButtonsB.forEach(button => {
                    // Uncheck all buttons
                    button.checked = false;
                });                
                
                const dynamicId = `All-${i}`;
                const dynamicIdB = `AllB-${i}`;
                
                // Find and check the radio button with the generated ID
                const allButton = document.querySelector(`input[type="radio"][id="${dynamicId}"]`);
                const allButtonB = document.querySelector(`input[type="radio"][id="${dynamicIdB}"]`);
                if (allButton) {
                    allButton.checked = true; // Check the radio button with id All-${i}
                }
                if (allButtonB) {
                    allButtonB.checked = true; // Check the radio button with id All-${i}
                }
            }                
        }); 
        
        toggleBtnB.addEventListener('click', () => {
            const isOpen = expandPanel.classList.toggle('open');
            expandPanel.classList.toggle('mb-4', isOpen);            
            filtersSection.classList.toggle('open', isOpen);
            filtersSectionB.classList.toggle('open', isOpen);            
            icon.classList.toggle('collapsed', !isOpen);
            iconB.classList.toggle('collapsed', !isOpen);            

            if(!isOpen) {
                rectangles.forEach(rectangle => {
                    rectangle.classList.remove('d-none');                    
                });

                // ---------------------------

                // When closing: de-select all buttons, and
                // select only the "All" button (so that you'll find it selected when you re open the section)
                filterButtons.forEach(button => {
                    // Uncheck all buttons
                    button.checked = false;
                });

                filterButtonsB.forEach(button => {
                    // Uncheck all buttons
                    button.checked = false;
                });
                
                const dynamicId = `All-${i}`;
                const dynamicIdB = `AllB-${i}`;
                
                // Find and check the radio button with the generated ID
                const allButton = document.querySelector(`input[type="radio"][id="${dynamicId}"]`);
                const allButtonB = document.querySelector(`input[type="radio"][id="${dynamicIdB}"]`);
                if (allButton) {
                    allButton.checked = true; // Check the radio button with id All-${i}
                }
                if (allButtonB) {
                    allButtonB.checked = true; // Check the radio button with id All-${i}
                }
            }
        }); 

        filterButtons.forEach(button => {
            button.addEventListener('change', function () {
                const selectedValue = this.value;

                rectangles.forEach(rectangle => {
                    const rectValue = rectangle.getAttribute('value');
                    if (!selectedValue || rectValue === selectedValue) {
                        rectangle.classList.remove('d-none');
                    } else {
                        rectangle.classList.add('d-none');
                    }
                });

                // If the button is selected, find the corresponding radio button in the second group
                const id = button.id.replace('-', 'B-'); // Replace "...-.." with "...B-.." to find the matching button                
                const correspondingButton = document.getElementById(id); // Find the radio button with the same id in the second group
                
                if (correspondingButton) {
                    correspondingButton.checked = true; // Select the corresponding radio button in the second group
                }
            });
        });

        filterButtonsB.forEach(button => {
            button.addEventListener('change', function () {
                const selectedValue = this.value;

                rectangles.forEach(rectangle => {
                    const rectValue = rectangle.getAttribute('value');
                    if (!selectedValue || rectValue === selectedValue) {
                        rectangle.classList.remove('d-none');
                    } else {
                        rectangle.classList.add('d-none');
                    }
                });

                const id = button.id.replace('B-', '-'); // Replace "...B-.." with "...-.." to find the matching button    
                const correspondingButton = document.getElementById(id);
                
                if (correspondingButton) {
                    correspondingButton.checked = true; // Select the corresponding radio button in the first group
                }
            });
        });
    }
}
